import { useMountEffect } from './useMountEffect';

// A semantic wrapper around useEffect for the case to only call on mount
export function useScrollToTopOnMountEffect() {
  return useMountEffect(() => {
    window.scrollTo(0, 0);
  });
}

export function ScrollToTopOnMount() {
  useScrollToTopOnMountEffect();
  return null;
};
